import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/bc-www/dist',
    routes: [{
        path: '/',
        name: 'root',
        redirect: {
            name: 'indexlayout',
            // name: 'SaiDateList',
        },
    },
    {
        path: '/indexUpdate',
        name: 'IndexUpdate',
        component: require('@/page/mainindex/IndexUpdate'),
    },
        {
            path: '/index',
            name: 'Index',
            component: require('@/page/index/Index'),
        },


        {
            path: '/sai-apply-form-step-1',
            name: 'SaiApplyFormStep1',
            component: require('@/page/apps/sai/SaiApplyFormStep1'),
        },
        {
            path: '/sai-apply-form-step-2',
            name: 'SaiApplyFormStep2',
            component: require('@/page/apps/sai/SaiApplyFormStep2'),
        },
        {
            path: '/sai-apply-form-step-3',
            name: 'SaiApplyFormStep3',
            component: require('@/page/apps/sai/SaiApplyFormStep3'),
        },
        {
            path: '/sai-apply-form-step-4',
            name: 'SaiApplyFormStep4',
            component: require('@/page/apps/sai/SaiApplyFormStep4'),
        },
        {
            path: '/sai-apply-form-step-5',
            name: 'SaiApplyFormStep5',
            component: require('@/page/apps/sai/SaiApplyFormStep5'),
        },

        {
            path: '/sai-files-list',
            name: 'SaiFilesList',
            component: require('@/page/apps/sai/SaiFilesList'),
        },
        {
            path: '/sai-result',
            name: 'SaiResult',
            component: require('@/page/apps/sai/SaiResult'),
        },
        {
            path: '/sai-start-list',
            name: 'SaiStartList',
            component: require('@/page/apps/sai/SaiStartList'),
        },


        {
            path: '/isai-vote-detail',
            name: 'ISaiVoteDetail',
            component: require('@/page/apps/isai/VoteDetail'),
        },
        {
            path: '/sai-confirm',
            name: 'saiConfirm',
            component: require('@/page/apps/sai/saiConfirm'),
        },
        {
            path: '/sai-confirm-detail1',
            name: 'saiConfirmDetail1',
            component: require('@/page/apps/sai/saiConfirmDetail1'),
        },
        {
            path: '/sai-confirm-detail2',
            name: 'saiConfirmDetail2',
            component: require('@/page/apps/sai/saiConfirmDetail2'),
        },
        {
            path: '/sai-confirm-detail3',
            name: 'saiConfirmDetail3',
            component: require('@/page/apps/sai/saiConfirmDetail3'),
        },
        {
            path: '/sai-confirm-detail4',
            name: 'saiConfirmDetail4',
            component: require('@/page/apps/sai/saiConfirmDetail4'),
        },
        {
            path: '/sai-confirm-detail5',
            name: 'saiConfirmDetail5',
            component: require('@/page/apps/sai/saiConfirmDetail5'),
        },
        {
            path: '/sai-confirm-detail-dinner',
            name: 'saiConfirmDetailDinner',
            component: require('@/page/apps/sai/SaiConfirmDetailDinner'),
        },
        {
            path: '/sai-confirm-manage',
            name: 'saiConfirmManage',
            component: require('@/page/apps/sai/SaiConfirmManage'),
        },
        {
            path: '/sai-confirm-qr1',
            name: 'saiConfirmQr1',
            component: require('@/page/apps/sai/SaiConfirmQr1'),
        },
        {
            path: '/sai-confirm-qr2',
            name: 'saiConfirmQr2',
            component: require('@/page/apps/sai/SaiConfirmQr2'),
        },
        {
            path: '/sai-my-sai',
            name: 'MySai',
            component: require('@/page/apps/sai/MySai'),
        },
        {
            path: '/activity',
            name: 'Activity',
            component: require('@/page/activity/Activity'),
        },
        {
            path: '/activity-my-activity',
            name: 'MyActivity',
            component: require('@/page/apps/activity/MyActivity'),
        },
        {
            path: '/activity-activity',
            name: 'ActivityActivity',
            component: require('@/page/apps/activity/Activity'),
        },
        // {
        //     path: '/activity-activity-detail',
        //     name: 'ActivityDetail',
        //     component: require('@/page/apps/activity/ActivityDetail'),
        // },
        {
            path: '/activity-activity-content-form',
            name: 'ActivityContentForm',
            component: require('@/page/apps/activity/activityContentForm'),
        },
        {
            path: '/activity-activity-pic-order-form',
            name: 'ActivityPicOrderForm',
            component: require('@/page/apps/activity/ActivityPicOrderForm'),
        },
        {
            path: '/activityDetail',
            name: 'ActivityDetail',
            component: require('@/page/activity/ActivityDetail'),
        },
        {
            path: '/activityList',
            name: 'ActivityList',
            component: require('@/page/activity/ActivityList'),
        },
        {
            path: '/competitionOrder',
            name: 'CompetitionOrder',
            component: require('@/page/activity/CompetitionOrder'),
        },
        {
            path: '/queryGrade',
            name: 'QueryGrade',
            component: require('@/page/activity/QueryGrade'),
        },
        {
            path: '/user-setting',
            name: 'UserSetting',
            component: require('@/page/user/mine/setting/Setting'),
        },

        {
            path: '/test',
            name: 'Test',
            component: require('@/page/index/Test'),
        },


        {
            path: '/cha-index',
            name: 'ChaIndex',
            component: require('@/page/apps/cha/ChaIndex'),
        },
        {
            path: '/cha-jiaolianList',
            name: 'ChaJiaolianList',
            component: require('@/page/apps/cha/JiaolianList'),
        },
        {
            path: '/cha-caipanList',
            name: 'ChaCaipanList',
            component: require('@/page/apps/cha/CaipanList'),
        },
        {
            path: '/cha-searchIndex',
            name: 'ChaSearchIndex',
            component: require('@/page/apps/cha/SearchIndex'),
        },
        {
            path: '/cha-searchAll',
            name: 'ChaSearchAll',
            component: require('@/page/apps/cha/SearchAll'),
        },
        {
            path: '/cha-searchPerson',
            name: 'ChaSearchPerson',
            component: require('@/page/apps/cha/SearchPerson'),
        },
        {
            path: '/cha-searchDanwei',
            name: 'ChaSearchDanwei',
            component: require('@/page/apps/cha/SearchDanwei'),
        },
        {
            path: '/cha-searchSai',
            name: 'ChaSearchSai',
            component: require('@/page/apps/cha/SearchSai'),
        },

        {
            path: '/huiyi-files-list',
            name: 'HuiyiFilesList',
            component: require('@/page/apps/huiyi/HuiyiFilesList'),
        },
        {
            path: '/wexame-my-exame-list',
            name: 'MyExameList',
            component: require('@/page/apps/wexame/MyExameList'),
        },

        {
            path: '/huiyi-list',
            name: 'HuiyiList',
            component: require('@/page/apps/huiyi/HuiyiList'),
        },

        {
            path: '/course-index',
            name: 'CourseIndex',
            component: require('@/page/apps/course/CourseIndex'),
        },
        {
            path: '/course-detail',
            name: 'CourseDetail2',
            component: require('@/page/apps/course/CourseDetail'),
        },
        {
            path: '/course-order-check',
            name: 'CourseOrderCheck',
            component: require('@/page/apps/course/CourseOrderCheck'),
        },
        {
            path: '/my-course-list',
            name: 'MyCourseList',
            component: require('@/page/apps/course/MyCourseList'),
        },
        {
            path: '/page-hangyejinying',
            name: 'PageHangyejinying',
            component: require('@/page/apps/page/Hangyejinying'),
        },
        {
            path: '/page-jigoushezhi',
            name: 'PageJigoushezhi',
            component: require('@/page/apps/page/Jigoushezhi'),
        },
        {
            path: '/page-saishizhaoshang',
            name: 'PageSaishizhaoshang',
            component: require('@/page/apps/page/Saishizhaoshang'),
        },
        {
            path: '/page-guojijiaoliu',
            name: 'PageGuojijiaoliu',
            component: require('@/page/apps/page/Guojijiaoliu'),
        },
        {
            path: '/page-wenhuaji',
            name: 'PageWenhuaji',
            component: require('@/page/apps/page/Wenhuaji'),
        },

        {
            path: '/cba-apply-list',
            name: 'CbaApplyList',
            component: require('@/page/apps/cba/CbaApplyList'),
        },
        {
            path: '/cba-apply-detail',
            name: 'CbaApplyDetail',
            component: require('@/page/apps/cba/CbaApplyDetail'),
        },
        {
            path: '/cba-apply-form-basic',
            name: 'CbaApplyFormBasic',
            component: require('@/page/apps/cba/CbaApplyFormBasic'),
        },
        {
            path: '/cba-apply-member-list',
            name: 'CbaApplyMemberList',
            component: require('@/page/apps/cba/CbaApplyMemberList'),
        },
        {
            path: '/cba-apply-member-add',
            name: 'CbaApplyMemberAdd',
            component: require('@/page/apps/cba/CbaApplyMemberAdd'),
        },
        {
            path: '/cba-apply-member-detail',
            name: 'CbaApplyMemberDetail',
            component: require('@/page/apps/cba/CbaApplyMemberDetail'),
        },
        {
            path: '/cba-apply-form-order',
            name: 'CbaApplyFormOrder',
            component: require('@/page/apps/cba/CbaApplyFormOrder'),
        },
        {
            path: '/h5',
            name: 'H5',
            component: require('@/page/index/H5'),
        },
        {
            path: '/indexlayout',
            name: 'indexlayout',
            redirect: '/indexpc',
            components: {
                default: require('@/page/mainindex/IndexLayout'),
            },
            children: [
                {
                    path: '/gbook',
                    name: 'Gbook',
                    component: require('@/page/mainindex/Gbook'),
                },
                {
                    path: '/qcxj-index',
                    name: 'QcxjIndex',
                    component: require('@/page/apps/qcxj/QcxjIndex'),
                },
                {
                    path: '/qcxj-station-apply',
                    name: 'QcxjStationApply',
                    component: require('@/page/apps/qcxj/StationApply'),
                },
                {
                    path: '/qcxj-station-bind',
                    name: 'QcxjStationBind',
                    component: require('@/page/apps/qcxj/StationBind'),
                },
                {
                    path: '/qcxj-station-list',
                    name: 'QcxjStationList',
                    component: require('@/page/apps/qcxj/StationList'),
                },
                {
                    path: '/qcxj-station-result',
                    name: 'QcxjStationResult',
                    component: require('@/page/apps/qcxj/StationResult'),
                },
                {
                    path: '/qcxj-station-cert',
                    name: 'QcxjStationCert',
                    component: require('@/page/apps/qcxj/StationCert'),
                },
                {
                    path: '/qcxj-exame-apply-list',
                    name: 'ExameApplyList',
                    component: require('@/page/apps/qcxj/ExameApplyList'),
                },
                {
                    path: '/qcxj-exame-apply-slist',
                    name: 'ExameApplySList',
                    component: require('@/page/apps/qcxj/ExameApplySList'),
                },
                {
                    path: '/qcxj-exame-apply-form-basic',
                    name: 'ExameApplyFormBasic',
                    component: require('@/page/apps/qcxj/ExameApplyFormBasic'),
                },
                {
                    path: '/qcxj-exame-apply-share-list',
                    name: 'ExameApplyShareList',
                    component: require('@/page/apps/qcxj/ExameApplyShareList'),
                },
                {
                    path: '/qcxj-exame-score-detail',
                    name: 'ExameScoreDetail',
                    component: require('@/page/apps/qcxj/ExameScoreDetail'),
                },
                {
                    path: '/qcxj-exame-apply-join',
                    name: 'ExameApplyJoin',
                    component: require('@/page/apps/qcxj/ExameApplyJoin'),
                },
                {
                    path: '/qcxj-exame-apply-join-detail',
                    name: 'ExameApplyJoinDetail',
                    component: require('@/page/apps/qcxj/ExameApplyJoinDetail'),
                },
                {
                    path: '/qcxj-exame-apply-join-member-list',
                    name: 'ExameApplyJoinMemberList',
                    component: require('@/page/apps/qcxj/ExameApplyJoinMemberList'),
                },
                {
                    path: '/qcxj-exame-apply-member-list',
                    name: 'ExameApplyMemberList',
                    component: require('@/page/apps/qcxj/ExameApplyMemberList'),
                },
                {
                    path: '/qcxj-exame-apply-member-detail',
                    name: 'ExameApplyMemberDetail',
                    component: require('@/page/apps/qcxj/ExameApplyMemberDetail'),
                },
                {
                    path: '/qcxj-exame-apply-order',
                    name: 'ExameApplyOrder',
                    component: require('@/page/apps/qcxj/ExameApplyOrder'),
                },
                {
                    path: '/qcxj-exame-apply-detail',
                    name: 'ExameApplyDetail',
                    component: require('@/page/apps/qcxj/ExameApplyDetail'),
                },
                {
                    path: '/qcxj-exame-apply-member-add-more',
                    name: 'ExameApplyMemberAddMore',
                    component: require('@/page/apps/qcxj/ExameApplyMemberAddMore'),
                },
                {
                    path: '/qcxj-exame-apply-member-add',
                    name: 'ExameApplyMemberAdd',
                    component: require('@/page/apps/qcxj/ExameApplyMemberAdd'),
                },
                {
                    path: '/huiyi-index',
                    name: 'HuiyiIndex',
                    component: require('@/page/apps/huiyi/HuiyiIndex'),
                },
                {
                    path: '/huiyi-apply-form-success',
                    name: 'HuiyiApplyFormSuccess',
                    component: require('@/page/apps/huiyi/HuiyiApplyFormSuccess'),
                },

                {
                    path: '/huiyi-apply-form-step-1',
                    name: 'HuiyiApplyFormStep1',
                    component: require('@/page/apps/huiyi/HuiyiApplyFormStep1'),
                },
                {
                    path: '/huiyi-apply-form-step-2',
                    name: 'HuiyiApplyFormStep2',
                    component: require('@/page/apps/huiyi/HuiyiApplyFormStep2'),
                },
                {
                    path: '/huiyi-apply-form-step-3',
                    name: 'HuiyiApplyFormStep3',
                    component: require('@/page/apps/huiyi/HuiyiApplyFormStep3'),
                },
                {
                    path: '/huiyi-apply-form-step-5',
                    name: 'HuiyiApplyFormStep5',
                    component: require('@/page/apps/huiyi/HuiyiApplyFormStep5'),
                },

                // 送培
                {
                    path: '/songpei-apply-form-basic',
                    name: 'SongpeiApplyFormBasic',
                    component: require('@/page/apps/songpei/SongpeiApplyFormBasic'),
                },

                {
                    path: '/songpei-apply-form-step1',
                    name: 'SongpeiApplyFormStep1',
                    component: require('@/page/apps/songpei/SongpeiApplyFormStep1'),
                },

                {
                    path: '/songpei-apply-form-step3',
                    name: 'SongpeiApplyFormStep3',
                    component: require('@/page/apps/songpei/SongpeiApplyFormStep3'),
                },
                {
                    path: '/songpei-apply-form-step2',
                    name: 'SongpeiApplyFormStep2',
                    component: require('@/page/apps/songpei/SongpeiApplyFormStep2'),
                },
                {
                    path: '/songpei-apply-form-success',
                    name: 'SongpeiApplyFormSuccess',
                    component: require('@/page/apps/songpei/SongpeiApplyFormSuccess'),
                },
                {
                    path: '/songpei-exame',
                    name: 'SongpeiExame',
                    component: require('@/page/apps/songpei/SongpeiExame'),
                },

                {
                    path: '/indexpc',
                    name: 'IndexPc',
                    meta: { hideIndexChrome: true },
                    component: require('@/page/mainindex/IndexPc'),
                },
                {
                    path: '/indexpc-age',
                    name: 'IndexPcAge',
                    meta: { hideIndexChrome: true },
                    component: require('@/page/mainindex/IndexPcAge'),
                },
                {
                    path: '/contactus',
                    name: 'ContactUs',
                    component: require('@/page/mainindex/ContactUs'),
                },
                {
                    path: '/cha',
                    name: 'Cha',
                    component: require('@/page/mainindex/Cha'),
                },
                {
                    path: '/businesscooperation',
                    name: 'BusinessCooperation',
                    component: require('@/page/mainindex/BusinessCooperation'),
                },
                {
                    path: '/coursesole',
                    name: 'CourseSole',
                    component: require('@/page/mainindex/CourseSole'),
                },
                {
                    path: '/tradeelite',
                    name: 'TradeElite',
                    component: require('@/page/mainindex/TradeElite'),
                },
                {
                    path: '/coursedetail',
                    name: 'CourseDetail',
                    component: require('@/page/mainindex/CourseDetail'),
                },
                {
                    path: '/organization',
                    name: 'Organization',
                    component: require('@/page/mainindex/Organization'),
                },
                {
                    path: '/culturalhistory',
                    name: 'CulturalHistory',
                    component: require('@/page/mainindex/CulturalHistory'),
                },
                {
                    path: '/jingwai',
                    name: 'jingwai',
                    component: require('@/page/mainindex/jingwai'),
                },
                {
                    path: '/jingwaiZhou',
                    name: 'jingwaiZhou',
                    component: require('@/page/mainindex/jingwaiZhou'),
                },
                {
                    path: '/infoquery',
                    name: 'InfoQuery',
                    component: require('@/page/mainindex/InfoQuery'),
                },

                {
                    path: '/course-list',
                    name: 'CourseList',
                    component: require('@/page/apps/course/CourseList'),
                },

                {
                    path: '/news-list',
                    name: 'NewsList',
                    component: require('@/page/apps/news/NewsList'),
                },
                {
                    path: '/notice-list',
                    name: 'NoticeList',
                    component: require('@/page/apps/news/NoticeList'),
                },
                {
                    path: '/news-detail',
                    name: 'NewsDetail',
                    component: require('@/page/apps/news/NewsDetail'),
                },
                {
                    path: '/cmslist',
                    name: 'CmsList',
                    component: require('@/page/mainindex/CmsList'),
                },
                {
                    path: '/cmsdetail',
                    name: 'CmsDetail',
                    component: require('@/page/mainindex/CmsDetail'),
                },
                //cmsdetail  的弹出小组件
                {
                    path: '/popcontent',
                    name: 'PopContent',
                    component: require('@/page/mainindex/PopContent'),
                },
                {
                    path: '/login',
                    name: 'Login',
                    component: require('@/page/index/login/Login'),
                },



                /***************seabert start***************/

                {
                    path: '/sai-data-list',
                    name: 'SaiDateList',
                    component: require('@/page/apps/sai/SaiDateList'),
                },
                {
                    path: '/user-member-yundongyuanlist',
                    name: 'YundongyuanList',
                    component: require('@/page/user/member/YundongyuanList'),
                },

                {
                    path: '/isai-apply-form-step-1',
                    name: 'ISaiApplyFormStep1',
                    component: require('@/page/apps/isai/SaiApplyFormStep1'),
                },
                {
                    path: '/isai-apply-form-step-2',
                    name: 'ISaiApplyFormStep2',
                    component: require('@/page/apps/isai/SaiApplyFormStep2'),
                },
                {
                    path: '/isai-apply-form-famliy-step-2',
                    name: 'ISaiApplyFormFamliyStep2',
                    component: require('@/page/apps/isai/SaiApplyFormFamliyStep2'),
                },
                {
                    path: '/isai-apply-form-step-3',
                    name: 'ISaiApplyFormStep3',
                    component: require('@/page/apps/isai/SaiApplyFormStep3'),
                },
                {
                    path: '/isai-apply-form-step-3-admin',
                    name: 'ISaiApplyFormStep3',
                    component: require('@/page/apps/isai/SaiApplyFormStep3Admin'),
                },
                {
                    path: '/isai-apply-form-step-4',
                    name: 'ISaiApplyFormStep4',
                    component: require('@/page/apps/isai/SaiApplyFormStep4'),
                },
                {
                    path: '/isai-apply-form-step-4-admin',
                    name: 'ISaiApplyFormStep4Admin',
                    component: require('@/page/apps/isai/SaiApplyFormStep4Admin'),
                },
                {
                    path: '/isai-apply-form-step-5',
                    name: 'ISaiApplyFormStep5',
                    component: require('@/page/apps/isai/SaiApplyFormStep5'),
                },
                {
                    path: '/isai-apply-form-step-6',
                    name: 'ISaiApplyFormStep6',
                    component: require('@/page/apps/isai/SaiApplyFormStep6'),
                },
                {
                    path: '/isai-apply-form-step-7',
                    name: 'ISaiApplyFormStep7',
                    component: require('@/page/apps/isai/SaiApplyFormStep7'),
                },
                {
                    path: '/isai-apply-form-success',
                    name: 'ISaiApplyFormSuccess',
                    component: require('@/page/apps/isai/SaiApplyFormSuccess'),
                },

                {
                    path: '/isai-apply-form-upload-video',
                    name: 'ISaiApplyFormUploadVideo',
                    component: require('@/page/apps/isai/SaiApplyFormUploadVideo'),
                },
                {
                    path: '/isai-apply-video-list',
                    name: 'ISaiApplyVideoList',
                    component: require('@/page/apps/isai/SaiApplyVideoList'),
                },
                {
                    path: '/isai-cert-list',
                    name: 'ISaiCertList',
                    component: require('@/page/apps/isai/SaiCertList'),
                },

                {
                    path: '/isai-apply-famliy-list',
                    name: 'ISaiApplyFamliyList',
                    component: require('@/page/apps/isai/SaiApplyFamliyList'),
                },
                {
                    path: '/isai-apply-detail',
                    name: 'ISaiApplyDetail',
                    component: require('@/page/apps/isai/SaiApplyDetail'),
                },
                {
                    path: '/isai-apply-beizhu',
                    name: 'ISaiApplyBeizhu',
                    component: require('@/page/apps/isai/SaiApplyBeizhu'),
                },
                {
                    path: '/isai-apply-famliy-detail',
                    name: 'ISaiApplyFamliyDetail',
                    component: require('@/page/apps/isai/SaiApplyFamliyDetail'),
                },
                {
                    path: '/isai-vote-list',
                    name: 'ISaiVoteList',
                    component: require('@/page/apps/isai/VoteList'),
                },
                {
                    path: '/isai-apply-form-step-2-music',
                    name: 'ISaiApplyFormStep2Music',
                    component: require('@/page/apps/isai/SaiApplyFormStep2Music'),
                },
                {
                    path: '/user-member-caipanlist',
                    name: 'CaipanList',
                    component: require('@/page/user/member/CaipanList'),
                },
                {
                    path: '/user-member-jiaolianlist',
                    name: 'JiaolianList',
                    component: require('@/page/user/member/JiaolianList'),
                },

                {
                    path: '/sai-apply-beizhu',
                    name: 'SaiApplyBeizhu',
                    component: require('@/page/apps/sai/SaiApplyBeizhu'),
                },
                {
                    path: '/sai-apply-file',
                    name: 'SaiApplyFile',
                    component: require('@/page/apps/sai/SaiApplyFile'),
                },
                {
                    path: '/sai-apply-form-success',
                    name: 'SaiApplyFormSuccess',
                    component: require('@/page/apps/sai/SaiApplyFormSuccess'),
                },
                {
                    path: '/sai-apply-fapiao',
                    name: 'SaiApplyFapiao',
                    component: require('@/page/apps/sai/SaiApplyFapiao'),
                },
                {
                    path: '/isai-apply-form-jiaolian-caipan',
                    name: 'ISaiApplyFormJiaolianCaipan',
                    component: require('@/page/apps/isai/SaiApplyFormJiaolianCaipan'),
                },
                /***************seabert end***************/


                {
                    path: '/club-index',
                    name: 'ClubIndex',
                    component: require('@/page/apps/club/ClubIndex'),
                },
                {
                    path: '/club-search-index',
                    name: 'ClubSearchIndex',
                    component: require('@/page/apps/club/ClubSearchIndex'),
                },
                {
                    path: '/club-detail-sihao',
                    name: 'ClubDetailSihao',
                    component: require('@/page/apps/club/ClubDetailSihao'),
                },
                {
                    path: '/club-shouquan-book',
                    name: 'ClubShouquanBook',
                    component: require('@/page/apps/club/ClubShouquanBook'),
                },
                {
                    path: '/club-high-apply',
                    name: 'ClubHighApply',
                    component: require('@/page/apps/club/ClubHighApply'),
                },
                {
                    path: '/club-high-apply-result',
                    name: 'ClubHighApplyResult',
                    component: require('@/page/apps/club/ClubHighApplyResult'),
                },
                {
                    path: '/club-danwei-apply',
                    name: 'ClubDanweiApply',
                    component: require('@/page/apps/club/ClubDanweiApply'),
                },
                {
                    path: '/club-danwei-apply-result',
                    name: 'ClubDanweiApplyResult',
                    component: require('@/page/apps/club/ClubDanweiApplyResult'),
                },
                {
                    path: '/club-detail-kaoji',
                    name: 'ClubDetailKaoji',
                    component: require('@/page/apps/club/ClubDetailKaoji'),
                },
                {
                    path: '/club-detail-score',
                    name: 'ClubDetailScore',
                    component: require('@/page/apps/club/ClubDetailScore'),
                },
                {
                    path: '/club-detail-danwei',
                    name: 'ClubDetailDanwei',
                    component: require('@/page/apps/club/ClubDetailDanwei'),
                },
                {
                    path: '/club-detail-fengcai',
                    name: 'ClubDetailFengcai',
                    component: require('@/page/apps/club/ClubDetailFengcai'),
                },
                {
                    path: '/club-detail-shenbao',
                    name: 'ClubDetailShenbao',
                    component: require('@/page/apps/club/ClubDetailShenbao'),
                },
                {
                    path: '/club-detail-sihao-apply',
                    name: 'ClubDetailSihaoApply',
                    component: require('@/page/apps/club/ClubDetailSihaoApply'),
                },
                {
                    path: '/club-detail-sihao-apply-success',
                    name: 'ClubDetailSihaoApplySuccess',
                    component: require('@/page/apps/club/ClubDetailSihaoApplySuccess'),
                },
                {
                    path: '/club-detail-mine',
                    name: 'ClubDetailMine',
                    component: require('@/page/apps/club/ClubDetailMine'),
                },
                {
                    path: '/club-detail-unbind',
                    name: 'ClubDetailUnbind',
                    component: require('@/page/apps/club/ClubDetailUnbind'),
                },
                {
                    path: '/club-detail',
                    name: 'ClubDetail',
                    component: require('@/page/apps/club/ClubDetail'),
                },
                {
                    path: '/club-detail-base',
                    name: 'ClubDetailBase',
                    component: require('@/page/apps/club/ClubDetailBase'),
                },
                {
                    path: '/club-detail-community',
                    name: 'ClubDetailCommunity',
                    component: require('@/page/apps/club/ClubDetailCommunity'),
                },
                {
                    path: '/club-detail-community-add',
                    name: 'ClubDetailCommunityAdd',
                    component: require('@/page/apps/club/ClubDetailCommunityAdd'),
                },
                {
                    path: '/club-apply-mine',
                    name: 'ClubApplyMine',
                    component: require('@/page/apps/club/ClubApplyMine'),
                },
                {
                    path: '/qcxj-club-index',
                    name: 'QcxjClubIndex',
                    component: require('@/page/apps/qcxj/QcxjClubIndex'),
                },
                {
                    path: '/qcxj-search-index',
                    name: 'QcxjSearchIndex',
                    component: require('@/page/apps/qcxj/QcxjSearchIndex'),
                },
                {
                    path: '/qcxj-detail-info',
                    name: 'QcxjDetailInfo',
                    component: require('@/page/apps/qcxj/QcxjDetailInfo'),
                },
                {
                    path: '/qcxj-detail-unbind',
                    name: 'QcxjDetailUnbind',
                    component: require('@/page/apps/qcxj/QcxjDetailUnbind'),
                },
                {
                    path: '/qcxj-detail-mine',
                    name: 'QcxjDetailMine',
                    component: require('@/page/apps/qcxj/QcxjDetailMine'),
                },

                {
                    path: '/qcxj-station-apply-mine',
                    name: 'QcxjStationApplyMine',
                    component: require('@/page/apps/qcxj/StationApplyMine'),
                },
                {
                    path: '/qcxj-detail',
                    name: 'QcxjDetail',
                    component: require('@/page/apps/qcxj/QcxjDetail.vue'),
                },

                {
                    path: '/qcxj-detail-base',
                    name: 'QcxjDetailBase',
                    component: require('@/page/apps/qcxj/QcxjDetailBase.vue'),
                },
                {
                    path: '/qcxj-detail-community',
                    name: 'QcxjDetailCommunity',
                    component: require('@/page/apps/qcxj/QcxjDetailCommunity.vue'),
                },
                {
                    path: '/qcxj-exame-apply-form-basic-mine',
                    name: 'ExameApplyFormBasicMine',
                    component: require('@/page/apps/qcxj/ExameApplyFormBasicMine'),
                },
                {
                    path: '/qcxj-exame-apply-detail-mine',
                    name: 'ExameApplyDetailMine',
                    component: require('@/page/apps/qcxj/ExameApplyDetailMine'),
                },
                // {
                //     path: '/qcxj-exame-apply-detail-share',
                //     name: 'ExameApplyDetailShare',
                //     component: require('@/page/apps/qcxj/ExameApplyDetailShare'),
                // },
                {
                    path: '/qcxj-detail-community-add',
                    name: 'QcxjDetailCommunityAdd',
                    component: require('@/page/apps/qcxj/QcxjDetailCommunityAdd.vue'),
                },
                {
                    path: '/qcxj-exame-apply-list-mine',
                    name: 'ExameApplyListMine',
                    component: require('@/page/apps/qcxj/ExameApplyListMine'),
                },

                {
                    path: '/qcxj-exame-apply-form-match',
                    name: 'ExameApplyFormMatch',
                    component: require('@/page/apps/qcxj/ExameApplyFormMatch'),
                },
                {
                    path: '/cdakejian-list',
                    name: 'DakejianList',
                    component: require('@/page/apps/cdakejian/DakejianList'),
                },
                {
                    path: '/cdakejian-detail',
                    name: 'CDakejianDetail',
                    component: require('@/page/apps/cdakejian/DakejianDetail'),
                },
                {
                    path: '/cdakejian-apple-simple',
                    name: 'DakejianApplySimple',
                    component: require('@/page/apps/cdakejian/DakejianApplySimple'),
                },

                {
                    path: '/page-yundongyuandengji',
                    name: 'PageYundongyuandengji',
                    component: require('@/page/apps/page/Yundongyuandengji'),
                },


                {
                    path: '/qcxj-exame-apply-order-mine',
                    name: 'ExameApplyOrderMine',
                    component: require('@/page/apps/qcxj/ExameApplyOrderMine'),
                },

                {
                    path: '/user-cert-personapply',
                    name: 'CertPersonApply',
                    component: require('@/page/user/cert/CertPersonApply'),
                },
                {
                    path: '/user-cert-personapplyother',
                    name: 'CertPersonApplyOther',
                    component: require('@/page/user/cert/CertPersonApplyOther'),
                },
                {
                    path: '/user-cert-personphoto',
                    name: 'CertPersonPhoto',
                    component: require('@/page/user/cert/CertPersonPhoto'),
                },

                {
                    path: '/user-searchCaipan',
                    name: 'UserSearchCaipan',
                    component: require('@/page/apps/cha/UserSearchCaipan'),
                },
                {
                    path: '/user-searchJiaolian',
                    name: 'UserSearchJiaolian',
                    component: require('@/page/apps/cha/UserSearchJiaolian'),
                },


                {
                    path: '/sai-score-caipan-apply',
                    name: 'SaiScoreCaipanApply',
                    component: require('@/page/apps/sai/SaiScoreCaipanApply'),
                },
                {
                    path: '/contentDetail',
                    name: 'ContentDetail',
                    component: require('@/page/index/cms/ContentDetail'),
                },


                {
                    path: '/user-skill-applylist',
                    name: 'LevelApplyList',
                    component: require('@/page/user/skill/LevelApplyList'),
                },
                {
                    path: '/user-skill-apply',
                    name: 'LevelApply',
                    component: require('@/page/user/skill/LevelApply'),
                },
                {
                    path: '/user-ability-apply',
                    name: 'AbilityApply',
                    component: require('@/page/user/skill/AbilityApply'),
                },
                {
                    path: '/user-skill-memberlist',
                    name: 'LevelApplyMemberList',
                    component: require('@/page/user/skill/LevelApplyMemberList'),
                },

                {
                    path: '/user-skill-member-add',
                    name: 'LevelApplyMemberAdd',
                    component: require('@/page/user/skill/LevelApplyMemberAdd'),
                },

                {
                    path: '/user-ability-member-add',
                    name: 'AbilityApplyMemberAdd',
                    component: require('@/page/user/skill/AbilityApplyMemberAdd'),
                },

                {
                    path: '/user-ability-applylist',
                    name: 'AbilityApplyList',
                    component: require('@/page/user/skill/AbilityApplyList'),
                },
                {
                    path: '/user-ability-memberlist',
                    name: 'AbilityApplyMemberList',
                    component: require('@/page/user/skill/AbilityApplyMemberList'),
                },

                {
                    path: '/user-ability-member-service',
                    name: 'AbilityApplyMemberService',
                    component: require('@/page/user/skill/AbilityApplyMemberService'),
                },
                /***************seabert start2 20211102***************/
                {
                    path: '/qcxj-club',
                    name: 'QcxjClub',
                    component: require('@/page/mainindex/QcxjClub'),
                },

                {
                    path: '/mineIndex',
                    name: 'MineIndex',
                    components: {
                        default: require('@/page/user/mine/MineLayout'),
                    },
                    redirect: '/updateinfo',
                    children: [
                        {
                            path: '/updateinfo',
                            name: 'UpdataInfo',
                            components: {
                                default: require('@/page/user/mine/UpdataInfo'),
                            },
                        },

                        {
                            path: '/user-password',
                            name: 'UserPassword',
                            component: require('@/page/user/mine/setting/Password'),
                        },

                        {
                            path: '/user-name',
                            name: 'Username',
                            component: require('@/page/user/mine/setting/Username'),
                        },
                        {
                            path: '/pay-password',
                            name: 'PayPassword',
                            component: require('@/page/user/mine/setting/PayPassword'),
                        },
                        {
                            path: '/set-phone',
                            name: 'SetPhone',
                            component: require('@/page/user/mine/setting/SetPhone'),
                        },


                        {
                            path: '/user-cert-certindex',
                            name: 'CertIndex',
                            component: require('@/page/user/cert/CertIndex'),
                        },
                        {
                            path: '/user-cert-certdanwei',
                            name: 'CertDanwei',
                            redirect:'/user-cert-certdanweiapply', 
                            component: require('@/page/user/cert/CertDanwei'),
                        },
                        {
                            path: '/user-cert-certdanweibind',
                            name: 'CertDanweiBind',
                            component: require('@/page/user/cert/CertDanweiBind'),
                        },
                        {
                            path: '/user-cert-certdanweiapply',
                            name: 'CertDanweiApply',
                            component: require('@/page/user/cert/CertDanweiApply'),
                        },
                        {
                            path: '/user-cert-certdanweiresult',
                            name: 'CertDanweiResult',
                            component: require('@/page/user/cert/CertDanweiResult'),
                        },

                        {
                            path: '/experience-my-experience',
                            name: 'MyExperience',
                            component: require('@/page/apps/experience/MyExperience'),
                        },
                        {
                            path: '/isai-apply-list',
                            name: 'ISaiApplyList',
                            component: require('@/page/apps/isai/SaiApplyList'),
                        },

                        {
                            path: '/huiyi-apply-list',
                            name: 'HuiyiApplyList',
                            component: require('@/page/apps/huiyi/HuiyiApplyList'),
                        },

                        {
                            path: '/songpei-apply-list',
                            name: 'SongpeiApplyList',
                            component: require('@/page/apps/songpei/SongpeiApplyList'),
                        },
                    ]
                },
                /***************seabert end2***************/
            ]
        }
    ],
})



// WEBPACK FOOTER //
// ./src/router/index.js